<template>
  <div class="YieldStatistics">
    <b-container class="bv-example-row px-0">
      <media :query="{ minWidth: '1650px' }">
        <b-row class="mx-0">
          <div
            style="width:100vw"
          >
            <b-row class="mx-0">
              <b-col
                cols="12"
                class="px-0 text-right mt-3 mb-1"
                style="font-size: 1rem"
              >
                <span class="my-0" id="elecboard-update-time">更新時間:</span>
                <span class="my-0" for="elecboard-update-time">{{
                  nowtime
                }}</span>
              </b-col>
              <b-col cols="1" class="px-0"></b-col>
              <b-col cols="11" class="px-0">
                <b-row class="mx-0 text-left mb-3">
                  <div class="col-5 p-0">
                    <b-row align-h="start" align-v="center">
                      <b-col cols="auto" class="home-tag">
                        {{
                          tabIndex == 0 ? "本月目標(Lot)：" : "本周目標(Lot)："
                        }}
                      </b-col>
                      <b-col cols="auto" class="home-tag-value text-right">
                        {{
                          tab_target == "-"
                            ? "-"
                            : tab_target.toLocaleString("en-US")
                        }}
                      </b-col>
                    </b-row>
                    <b-row align-h="start" align-v="center">
                      <b-col cols="auto" class="home-tag">
                        {{
                          tabIndex == 0 ? "目前完成(Lot)：" : "目前完成(Lot)："
                        }}
                      </b-col>
                      <b-col cols="auto" class="home-tag-value text-right">
                        {{
                          tab_finish == "-"
                            ? "-"
                            : tab_finish.toLocaleString("en-US")
                        }}
                      </b-col>
                    </b-row>
                    <!-- <p class="home-tag py-2">
                      {{
                        tabIndex == 0 ? "本月目標(Lot)：" : "本周目標(Lot)："
                      }}
                      <span>{{
                        tab_target == "-"
                          ? "-"
                          : tab_target.toLocaleString("en-US")
                      }}</span>
                    </p>
                    <p class="home-tag py-2">
                      {{
                        tabIndex == 0 ? "目前完成(Lot)：" : "目前完成(Lot)："
                      }}
                      <span>{{
                        tab_finish == "-"
                          ? "-"
                          : tab_finish.toLocaleString("en-US")
                      }}</span>
                    </p> -->
                  </div>
                  <div class="col-5 p-0">
                    <b-row align-h="start" align-v="center">
                      <b-col cols="auto" class="home-tag">
                        {{
                          tabIndex == 0
                            ? "本月訂單尚餘(Lot)："
                            : "本周訂單尚餘(Lot)："
                        }}
                      </b-col>
                      <b-col cols="auto" class="home-tag-value mr-3">
                        {{
                          tab_remain == "-"
                            ? "-"
                            : tab_remain.toLocaleString("en-US")
                        }}
                      </b-col>
                    </b-row>
                    <b-row align-h="start" align-v="center">
                      <b-col cols="auto" class="home-tag">
                        {{
                          tabIndex == 0
                            ? "上月欠單尚餘(Lot)："
                            : "上周欠單尚餘(Lot)："
                        }}
                      </b-col>
                      <b-col cols="auto" class="home-tag-value mr-3">
                        {{
                          tab_p_remain == "-"
                            ? "-"
                            : tab_p_remain.toLocaleString("en-US")
                        }}
                      </b-col>
                    </b-row>
                    <!-- <p class="home-tag py-2">
                      {{
                        tabIndex == 0
                          ? "本月訂單尚餘(Lot)："
                          : "本周訂單尚餘(Lot)："
                      }}
                      <span>{{
                        tab_remain == "-"
                          ? "-"
                          : tab_remain.toLocaleString("en-US")
                      }}</span>
                    </p>
                    <p class="home-tag py-2">
                      {{
                        tabIndex == 0
                          ? "上月欠單尚餘(Lot)："
                          : "上周欠單尚餘(Lot)："
                      }}
                      <span>{{
                        tab_p_remain == "-"
                          ? "-"
                          : tab_p_remain.toLocaleString("en-US")
                      }}</span>
                    </p> -->
                  </div>
                </b-row>
                <b-row class="mx-0 mb-3" style="min-width: 1070px">
                  <b-col cols="12" class="px-0">
                    <b-tabs class="customizeTab" v-model="tabIndex">
                      <b-tab
                        title="本月產量統計"
                        class=""
                        style="min-width: 75rem"
                        lazy
                      >
                        <b-col cols="12" class="px-0 home-title">
                          本月產量成長分析
                        </b-col>
                        <b-col
                          cols="12"
                          class="px-0"
                          style="height: 220px; background-color: #f2f2f2"
                        >
                          <singleChart class="text-left" />
                        </b-col>
                      </b-tab>

                      <b-tab
                        title="本周產量統計"
                        class=""
                        style="min-width: 75rem"
                        lazy
                      >
                        <b-col cols="12" class="px-0 home-title">
                          本周產量成長分析
                        </b-col>
                        <b-col
                          cols="12"
                          class="px-0"
                          style="height: 220px; background-color: #f2f2f2"
                        >
                          <singleChart class="text-left" />
                        </b-col>
                      </b-tab>
                    </b-tabs>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-row>
      </media>
      <media :query="{ maxWidth: '1650px' }">
        <b-row class="mx-0">
          <b-col
            cols="12"
            class="px-0 text-right mt-3 mb-1"
            style="font-size: 1rem"
          >
            <span class="my-0" id="elecboard-update-time">更新時間:</span>
            <span class="my-0" for="elecboard-update-time">{{ nowtime }}</span>
          </b-col>

          <b-col cols="1" class="px-0"></b-col>
          <b-col cols="10" class="px-0">
            <b-row class="mx-0 text-left mb-3">
              <div class="col-5 p-0">
                <b-row align-h="start" align-v="center">
                  <b-col cols="auto" class="home-tag">
                    {{ tabIndex == 0 ? "本月目標(Lot)：" : "本周目標(Lot)：" }}
                  </b-col>
                  <b-col cols="auto" class="home-tag-value text-right">
                    {{
                      tab_target == "-"
                        ? "-"
                        : tab_target.toLocaleString("en-US")
                    }}
                  </b-col>
                </b-row>
                <b-row align-h="start" align-v="center">
                  <b-col cols="auto" class="home-tag">
                    {{ tabIndex == 0 ? "目前完成(Lot)：" : "目前完成(Lot)：" }}
                  </b-col>
                  <b-col cols="auto" class="home-tag-value text-right">
                    {{
                      tab_finish == "-"
                        ? "-"
                        : tab_finish.toLocaleString("en-US")
                    }}
                  </b-col>
                </b-row>
                <!-- <p class="home-tag py-2">
                  {{ tabIndex == 0 ? "本月目標(Lot)：" : "本周目標(Lot)：" }}
                  <span>{{
                    tab_target == "-" ? "-" : tab_target.toLocaleString("en-US")
                  }}</span>
                </p>
                <p class="home-tag py-2">
                  {{ tabIndex == 0 ? "目前完成(Lot)：" : "目前完成(Lot)：" }}
                  <span>{{
                    tab_finish == "-" ? "-" : tab_finish.toLocaleString("en-US")
                  }}</span>
                </p> -->
              </div>
              <div class="col-5 p-0">
                <b-row align-h="start" align-v="center">
                  <b-col cols="auto" class="home-tag">
                    {{
                      tabIndex == 0
                        ? "本月訂單尚餘(Lot)："
                        : "本周訂單尚餘(Lot)："
                    }}
                  </b-col>
                  <b-col cols="auto" class="home-tag-value text-right">
                    {{
                      tab_remain == "-"
                        ? "-"
                        : tab_remain.toLocaleString("en-US")
                    }}
                  </b-col>
                </b-row>
                <b-row align-h="start" align-v="center">
                  <b-col cols="auto" class="home-tag">
                    {{
                      tabIndex == 0
                        ? "上月欠單尚餘(Lot)："
                        : "上周欠單尚餘(Lot)："
                    }}
                  </b-col>
                  <b-col cols="auto" class="home-tag-value text-right">
                    {{
                      tab_p_remain == "-"
                        ? "-"
                        : tab_p_remain.toLocaleString("en-US")
                    }}
                  </b-col>
                </b-row>
                <!-- <p class="home-tag py-2">
                  {{
                    tabIndex == 0
                      ? "本月訂單尚餘(Lot)："
                      : "本周訂單尚餘(Lot)："
                  }}
                  <span>{{
                    tab_remain == "-" ? "-" : tab_remain.toLocaleString("en-US")
                  }}</span>
                </p>
                <p class="home-tag py-2">
                  {{
                    tabIndex == 0
                      ? "上月欠單尚餘(Lot)："
                      : "上周欠單尚餘(Lot)："
                  }}
                  <span>{{
                    tab_p_remain == "-"
                      ? "-"
                      : tab_p_remain.toLocaleString("en-US")
                  }}</span>
                </p> -->
              </div>
            </b-row>
            <b-row class="mx-0 mb-3" style="min-width: 1070px">
              <b-col cols="12" class="px-0">
                <b-tabs class="customizeTab" v-model="tabIndex">
                  <b-tab
                    title="本月產量統計"
                    class=""
                    style="min-width: 75rem"
                    lazy
                  >
                    <b-col cols="12" class="px-0 home-title">
                      本月產量成長分析
                    </b-col>
                    <b-col
                      cols="12"
                      class="px-0"
                      style="height: 220px; background-color: #f2f2f2"
                    >
                      <singleChart class="text-left" />
                    </b-col>
                  </b-tab>

                  <b-tab
                    title="本周產量統計"
                    class=""
                    style="min-width: 75rem"
                    lazy
                  >
                    <b-col cols="12" class="px-0 home-title">
                      本周產量成長分析
                    </b-col>
                    <b-col
                      cols="12"
                      class="px-0"
                      style="height: 220px; background-color: #f2f2f2"
                    >
                      <singleChart class="text-left" />
                    </b-col>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </media>
    </b-container>
  </div>
</template>

<script>
import singleChart from "@/components/singleChart.vue";
import { mapGetters, mapActions } from "vuex";
import Media from "vue-media";

export default {
  name: "YieldStatistics",
  data() {
    return {
      tabIndex: 0,
      nowtime: "--",
      month_head: {},
      week_head: {},
      tab_target: "-",
      tab_finish: "-",
      tab_remain: "-",
      tab_p_remain: "-",
      monthTotalChart: {
        name: {
          chartId: "monthTotalChart",
          chartName: "",
        },
        options: [
          {
            text: "依月份",
            value: {
              name: "monthTotalChart-chart",
              data: {
                senTime: [
                  // "2020年1月1日",
                  // "2020年1月2日",
                  // "2020年1月3日",
                  // "2020年1月4日",
                  // "2020年1月5日",
                  // "2020年1月6日",
                  // "2020年1月7日",
                  // "2020年1月8日",
                  // "2020年1月9日",
                  // "2020年1月10日",
                ],
                senData: {
                  line: {
                    // 打頭: {
                    //   data: [200, 0, 50, 90, 71, 39, 42, 61, 188, 190],
                    //   color: "#427ace",
                    // },
                    // 輾牙: {
                    //   data: [180, 0, 42, 78, 60, 41, 45, 60, 188, 172],
                    //   color: "#009245",
                    // },
                    // 熱處理: {
                    //   data: [180, 0, 38, 72, 60, 40, 44, 60, 180, 170],
                    //   color: "#ff6b00",
                    // },
                  },
                },
                senType: "LineVerticalBar",
                yAxis: {
                  name: "支數",
                  type: "value",
                },
                legend_group: {},
              },
            },
          },
        ],
      },
      weekTotalChart: {
        name: {
          chartId: "weekTotalChart",
          chartName: "",
        },
        options: [
          // {
          //   text: "依機台",
          //   value: {
          //     name: "weekTotalAlarmChart-device",
          //     data: {
          //       senTime: [],
          //       senData: {
          //         bar: {},
          //         line: {
          //           name: "平均警報次數",
          //           data: [],
          //           color: "#FF3300",
          //         },
          //         unit: "次數",
          //       },
          //       senType: "VerticalBarLine",
          //     },
          //   },
          // },
          {
            text: "依本周",
            value: {
              name: "weekTotalChart-chart",
              data: {
                senTime: [
                  // "周一",
                  // "周二",
                  // "周三",
                  // "周四",
                  // "周五",
                  // "周六",
                  // "周日",
                ],
                senData: {
                  line: {
                    // 打頭: {
                    //   data: [60, 60, 60, 60, 60, 60, 60],
                    //   color: "#427ace",
                    // },
                    // 輾牙: {
                    //   data: [50, 50, 50, 50, 50, 50, 50],
                    //   color: "#009245",
                    // },
                    // 熱處理: {
                    //   data: [50, 50, 50, 50, 50, 50, 50],
                    //   color: "#ff6b00",
                    // },
                  },
                  // unit: "支數",
                },
                senType: "LineVerticalBar",
                yAxis: {
                  name: "支數",
                  type: "value",
                },
                legend_group: { data: [] },
              },
            },
          },
        ],
      },
    };
  },
  created: function () {
    this.change_selectPage("yieldstatistics");
    this.change_selectPageName(this.pageName.yieldstatistics);
    this.set_singleChartName(this.monthTotalChart.name);
    this.set_singleChartSelected(this.monthTotalChart.options[0].value);
    this.set_singleChartOptions(this.monthTotalChart.options);
    var myEvent = new Event("resize");
    window.dispatchEvent(myEvent);
    this.get_yieldStatistics();
  },
  mounted: function () {
    let vm = this;
    // vm.resetExportCsv();
    // vm.setExportDataTitle();
  },
  components: {
    singleChart,
    Media,
  },
  watch: {
    tabIndex: {
      handler() {
        let vm = this;
        if (vm.tabIndex == 0) {
          vm.tab_target = vm.month_head.mon_target;
          vm.tab_finish = vm.month_head.mon_finish;
          vm.tab_remain = vm.month_head.mon_remain;
          vm.tab_p_remain = vm.month_head.p_mon_remain;
          // vm.monthTotalChart.options[0].value.data.yAxis["max"] =
          //   vm.month_head.mon_target;
          vm.set_singleChartName(vm.monthTotalChart.name);
          vm.set_singleChartSelected(vm.monthTotalChart.options[0].value);
          vm.set_singleChartOptions(vm.monthTotalChart.options);
        } else if (vm.tabIndex == 1) {
          vm.tab_target = vm.week_head.wk_target;
          vm.tab_finish = vm.week_head.wk_finish;
          vm.tab_remain = vm.week_head.wk_remain;
          vm.tab_p_remain = vm.week_head.p_wk_remain;
          // vm.weekTotalChart.options[0].value.data.yAxis["max"] =
          //   vm.week_head.wk_target;
          vm.set_singleChartName(vm.weekTotalChart.name);
          vm.set_singleChartSelected(vm.weekTotalChart.options[0].value);
          vm.set_singleChartOptions(vm.weekTotalChart.options);
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage",
      pageName: "getlogin/get_pageName",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_singleChartSelected: "singleChart/set_singleChartSelected",
      set_singleChartOptions: "singleChart/set_singleChartOptions",
      set_singleChartName: "singleChart/set_singleChartName",
      clear_singleChart: "singleChart/clear_singleChart",
      set_exportData: "exportcsv/set_exportData",
      set_exportDataTitle: "exportcsv/set_exportDataTitle",
      set_exportFileName: "exportcsv/set_exportFileName",
    }),
    get_yieldStatistics() {
      let vm = this;
      if (vm.selectPage != "yieldstatistics") {
        return;
      }
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "GET";
      params["whichFunction"] = "MainQuery";
      vm.query_time = new Date();
      vm.axiosAction(params).then(() => {
        vm.searching = false;
        var result = vm.axiosResult;
        console.log(result);
        if (result.Response == "ok") {
          let result_data = result["QueryTableData"][0];
          let month_head = result_data.month_head;
          let week_head = result_data.week_head;
          vm.month_head = month_head;
          vm.week_head = week_head;
          vm.monthTotalChart.options[0].value.data.senTime =
            result_data.month.data_time;
          vm.monthTotalChart.options[0].value.data.senData.line = {
            支數: result_data.month.data["sum"]["支數"],
            本月目標: result_data.month.data["target"]["本月目標"],
          };
          vm.monthTotalChart.options[0].value.data.senData.bar =
            result_data.month.data["single"];
          vm.weekTotalChart.options[0].value.data.senTime =
            result_data.week.data_time;
          vm.weekTotalChart.options[0].value.data.senData.line = {
            支數: result_data.week.data["sum"]["支數"],
            本周目標: result_data.week.data["target"]["本周目標"],
          };
          // result_data.week.data["sum"];
          vm.weekTotalChart.options[0].value.data.senData.bar =
            result_data.week.data["single"];
          if (vm.tabIndex == 0) {
            vm.tab_target = month_head.mon_target;
            vm.tab_finish = month_head.mon_finish;
            vm.tab_remain = month_head.mon_remain;
            vm.tab_p_remain = month_head.p_mon_remain;
            // vm.monthTotalChart.options[0].value.data.yAxis["max"] =
            //   month_head.mon_target;
            vm.set_singleChartName(vm.monthTotalChart.name);
            vm.set_singleChartSelected(vm.monthTotalChart.options[0].value);
            vm.set_singleChartOptions(vm.monthTotalChart.options);
          } else if (vm.tabIndex == 1) {
            vm.tab_target = week_head.wk_target;
            vm.tab_finish = week_head.wk_finish;
            vm.tab_remain = week_head.wk_remain;
            vm.tab_p_remain = week_head.p_wk_remain;
            // vm.weekTotalChart.options[0].value.data.yAxis["max"] =
            //   week_head.wk_target;
            vm.set_singleChartName(vm.weekTotalChart.name);
            vm.set_singleChartSelected(vm.weekTotalChart.options[0].value);
            vm.set_singleChartOptions(vm.weekTotalChart.options);
          }
        }
        vm.getNowTime();
        // if (vm.query_time != null) {
        //   vm.query_time = null;
        //   setTimeout(function () {
        //     vm.get_factory_data();
        //   }, 4000);
        // }
      });
    },
    resetExportCsv() {
      let vm = this;
      vm.set_exportData([]);
      vm.set_exportDataTitle([]);
      vm.set_exportFileName("");
    },
    setExportDataTitle() {
      let vm = this;
      let exportDataTitle = [];
      vm.fields.forEach((data) => {
        exportDataTitle.push(data.label);
      });
      vm.set_exportDataTitle(exportDataTitle);
    },
    getNowTime() {
      let vm = this;
      let Today = new Date();
      vm.nowtime =
        Today.getFullYear() +
        "-" +
        String(Today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(Today.getDate()).padStart(2, "0") +
        " " +
        String(Today.getHours()).padStart(2, "0") +
        ":" +
        String(Today.getMinutes()).padStart(2, "0") +
        ":" +
        String(Today.getSeconds()).padStart(2, "0");
      console.log(vm.nowtime);
      vm.elecboard_detail_height = this.$refs.elecboard_detail.clientHeight;
      // setTimeout(function () {
      //   vm.getNowTime();
      // }, 1000);
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    },
  },
  destroyed() {
    // this.clear_singleChart();
    // this.clearTimer();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<style lang="scss">
.home-tag {
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  color: #666666;
  //靠右對齊
}
.home-tag-value {
  font-size: 1.875rem;
  color: #ff0000;
  min-width: 215px;
}
.home-title {
  min-width: 75rem;
  height: 2.5rem;
  line-height: 2.5rem;
  background-color: #4b8c80;
  color: #ffffff;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
}
</style>
<style lang="scss">
.customizeTab > div > ul {
  height: 1.9rem;
}
.customizeTab > div > ul > li > a {
  height: 1.9rem;
  line-height: 1.9rem;
  font-size: 1rem;
  padding: 0px;
  width: 12.5rem;
}
.nav-tabs .nav-link {
  border-top-left-radius: 0.63rem;
  border-top-right-radius: 0.63rem;
  background-color: #c8c9ca;
  font-size: 1rem;
  font-family: dfyuanstd-w5, dfyuanstd-w3;
  color: #666666;
  margin-right: 0.2rem;
}
.nav-tabs .nav-item {
  margin-bottom: 0px;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  border-color: transparent;
  background-color: #4b8c80;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/views/YieldStatistics.vue